<template>
  <div>
    <!-- 查询 -->
    <sirui-search
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
      @changeMethod="changeMethod"
    ></sirui-search>
    <!-- 表单列表 -->
    <sirui-table
      ref="siruiTable"
      :buttonList="menuButtonList"
      :loading="load"
      :data="tableData"
      :paging="true"
      :setting="false"
      :customVisible="true"
      :columns="columnListDefault"
      :showToolbar="true"
      @chooseClick="chooseClick"
      @handleSelectionChange="handleSelectionChange"
      @dblclickEvent="dblclickEvent"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <vxe-table-column type="checkbox" fixed="left" width="50"></vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnListDefault"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title ? $t(item.title) : null"
        :visible="item.visible"
        :type="item.type"
        :width="item.width"
      >
        <template v-slot="{ row }">
          <template v-if="item.field === 'workOrderNo'">
            <a @click="jumpToWorkOrderDetail(row)" href="#" style="color: #009fcc">{{
              row[item.field]
            }}</a>
          </template>
          <template v-else-if="item.field === 'repairNo'">
            <a @click="jumpToWorkRepairDetail(row)" href="#" style="color: #009fcc">{{
              row[item.field]
            }}</a>
          </template>
          <template v-else>{{ row[item.field] }}</template>
        </template>
      </vxe-table-column>
    </sirui-table>
  </div>
</template>

<script>
  import { columnListDefault, searchFormColumns } from './index.js';
  import API from '@/api/property/workorder';
  import { formatDate } from '@/utils/date';
  import mixin from './mixin.js';
  import btnMixins from './btnMixins.js';
  import moment from 'moment';
  export default {
    name: 'WorkorderManagement',
    mixins: [mixin, btnMixins],
    data() {
      return {
        menuButtonList: [],
        load: false,
        query: {
          workOrderCompanyNo: '',
          pageNum: 1,
          pageSize: 10,
          type: '',
          workOrderStatus: '',
          workOrderDepartmentNo: '',
        },
        columnListDefault: columnListDefault,
        tableData: [],
        row: [],
        multipleSelection: [],
        ids: [],
      };
    },
    computed: {
      searchFormColumns() {
        return searchFormColumns(this);
      },
    },
    mounted() {
      this.query.workOrderCompanyNo = this.userInfo.companyCode;
      this.getButtonList();
      this.getColumnInfo();
      // this.getDepartment();
      // this.getCompany();
      this.getTableData();
      this.getDepartment(this.userInfo.companyCode);
    },

    methods: {
      // 查询
      async queryBtnClickHandler() {
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.query = {
          workOrderCompanyNo: this.userInfo.companyCode,
          workOrderDepartmentNo: '',
        };
        this.getTableData();
      },
      // 分页获取数据
      async getTableData() {
        this.isLoading = true;
        const postData = {
          ...this.query,
          dispatchDateStart: this.query.dispatchDateStart
            ? formatDate(this.query.dispatchDateStart)
            : '',
          dispatchDateEnd: this.query.dispatchDateEnd
            ? moment(this.query.dispatchDateEnd).format('YYYY-MM-DD 24:00:00')
            : '',
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const { data } = await this.$axios.post(API.QUERY_WORKORDER_PAGE, postData);
        this.isLoading = false;
        if (data.code == 0) {
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.tableData = Object.freeze(this.translateFiled(data.data.records, 'page'));
        } else {
          this.$message.error('查询表格数据失败');
          this.tableData = [];
        }
      },
      // 选中行
      handleSelectionChange(row) {
        this.row = row;
        // console.log(row[0].id,'id',row)
        // this.ids.push(row.id)
        this.multipleSelection = row.selection;
      },
      // 双击
      dblclickEvent() {},
      // 跳转到工单详情
      jumpToWorkOrderDetail(value) {
        const id = value.id;
        const path = {
          path: 'property/workorderDetail',
          name: 'WorkorderDetail',
          meta: {
            keepAlive: true,
            title: '工单详情',
          },
          query: {
            id,
          },
        };
        this.$router.push(path);
      },
      // 跳转到报修单详情
      jumpToWorkRepairDetail(value) {
        // console.log('跳转到报修单详情');
        const repairId = value.repairId;
        // console.log('repairId', repairId);
        const path = {
          path: 'property/repairBillDetail',
          name: 'repairBillDetail',
          meta: {
            keepAlive: true,
            title: '报修单详情',
          },
          query: {
            repairId,
            pageMode: 4,
          },
        };
        this.$router.push(path);
      },

      // 导出
      exportClick() {
        if (this.tableData.length == 0) {
          this.$message.error('暂无数据');
          return;
        }
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        this.query.pageNum = pageNum;
        this.query.pageSize = pageSize;
        this.query.ids = this.row.map((item) => {
          return item.id;
        });
        this.exportLoading = true;
        this.$axios.post(API.WORKORDER_EXPORT, this.query).then((res) => {
          this.exportLoading = false;
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },

      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        // baseColumnListDefault
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // 判断行的选择
      judge() {
        if (this.row.length > 1) {
          this.$message({
            type: 'error',
            message: '请选择一条数据！',
          });
          return false;
        }
        if (!this.row.length) {
          this.$message({
            type: 'error',
            message: '请选择数据！',
          });
          return false;
        }
        return true;
      },
      printHandle() {
        if (!this.row.length) {
          this.$message({
            type: 'error',
            message: '请选择数据！',
          });
          return;
        }
        const list = this.row.filter((v) => v.workOrderStatus == '04');
        if (list.length != this.row.length) {
          this.$message({
            type: 'error',
            message: '请选择验收通过数据！',
          });
          return;
        }
        const ids = this.row.map((v) => v.id).join(',');
        const routeData = this.$router.resolve({
          name: `workOrderPrint`,
          query: {
            ids,
            access_token: this.userInfo.access_token,
          },
        });
        window.open(routeData.href);
        this.$router.go(0);
        this.resetBtnClick();
      },
      // 获取表格上面的按钮
      chooseClick(type) {
        this[type]();
      },
    },
  };
</script>

<style scoped>
  .button-group {
    margin-bottom: -20px;
    margin-top: 20px;
  }
</style>
